/* eslint-disable @typescript-eslint/no-unused-vars */
import { InputWithLabel } from '@adotel/components'
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Divider
} from '@material-ui/core'

import { getTranslate } from '../../../../localization'
import { ModifyReservationInput } from '../../../../types/modifyReserveTAPanel'
import { useStyles } from './styles/index.styles'

type BookingFormProps = {
  modifyReservationInput: ModifyReservationInput
  setModifyReservationInput: React.Dispatch<
    React.SetStateAction<ModifyReservationInput>
  >
  disabled: boolean
}
const BookingForm = ({
  modifyReservationInput,
  setModifyReservationInput,
  disabled
}: BookingFormProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.top}>
        <Typography variant="h4" className={classes.header}>
          {getTranslate('Booking Form')}
        </Typography>
      </div>
      <Divider />
      <div className={classes.middle}>
        <div className={classes.row}>
          <InputWithLabel
            label={getTranslate('First Name')}
            value={modifyReservationInput?.booker?.firstName}
            className={classes.input}
            disabled={disabled}
            onChange={(e) => {
              setModifyReservationInput({
                ...modifyReservationInput,
                booker: {
                  ...modifyReservationInput.booker,
                  firstName: e.currentTarget.value
                }
              })
            }}
          />
          <InputWithLabel
            label={getTranslate('Last Name')}
            value={modifyReservationInput?.booker?.lastName}
            className={classes.input}
            disabled={disabled}
            onChange={(e) => {
              setModifyReservationInput({
                ...modifyReservationInput,
                booker: {
                  ...modifyReservationInput.booker,
                  lastName: e.currentTarget.value
                }
              })
            }}
          />
          <InputWithLabel
            label={getTranslate('Email')}
            value={modifyReservationInput?.booker?.email}
            className={classes.input}
            disabled={disabled}
            autoComplete="email"
            type="email"
            onChange={(e) => {
              setModifyReservationInput({
                ...modifyReservationInput,
                booker: {
                  ...modifyReservationInput.booker,
                  email: e.currentTarget.value
                }
              })
            }}
          />
        </div>
        <div className={classes.row}>
          <InputWithLabel
            label={getTranslate('Phone Number')}
            value={modifyReservationInput?.booker?.telephone}
            className={classes.input}
            disabled={disabled}
            onKeyDown={(e) => {
              if (e.key === '-' || e.key === 'e' || e.key === '.') {
                e.preventDefault()
              }
            }}
            onChange={(e) => {
              setModifyReservationInput({
                ...modifyReservationInput,
                booker: {
                  ...modifyReservationInput.booker,
                  telephone: e.currentTarget.value
                }
              })
            }}
          />
          <InputWithLabel
            label={getTranslate('Identification Number')}
            value={modifyReservationInput?.booker?.idNumber}
            className={classes.input}
            disabled={disabled}
            onKeyDown={(e) => {
              if (
                e.key === '-' ||
                e.key === 'e' ||
                e.key === '+' ||
                e.key === '.'
              ) {
                e.preventDefault()
              }
            }}
            onChange={(e) => {
              setModifyReservationInput({
                ...modifyReservationInput,
                booker: {
                  ...modifyReservationInput.booker,
                  idNumber: e.currentTarget.value
                }
              })
            }}
          />
        </div>
      </div>
      <div className={classes.bottom}>
        <RadioGroup
          row
          value={
            modifyReservationInput?.booker.isForeigner ? 'Foreign' : 'Iranian'
          }
          aria-disabled={disabled}
          onChange={(e) => {
            const isForeign = e.target.value === 'Foreign'
            setModifyReservationInput({
              ...modifyReservationInput,
              booker: {
                ...modifyReservationInput?.booker,

                isForeigner: isForeign
              }
            })
          }}>
          <FormControlLabel
            value="Iranian"
            control={
              <Radio
                color="primary"
                disabled={disabled}
                classes={{
                  root: classes.radioIcon
                }}
              />
            }
            label={getTranslate('Iranian Guest')}
            classes={{ label: classes.label }}
          />
          <FormControlLabel
            value="Foreign"
            control={
              <Radio
                color="primary"
                disabled={disabled}
                classes={{
                  root: classes.radioIcon
                }}
              />
            }
            label={getTranslate('Foreign Guest')}
            classes={{ label: classes.label }}
          />
        </RadioGroup>
      </div>
    </div>
  )
}

export default BookingForm
